import { IOrderComposition } from "../../../../../modules/cart/domain/models/IOrderComposition"
import { IProductComposition } from "../../../../../modules/catalog/domain/models/IProductComposition"
import { PrincingTypeEnum } from "../../../../../modules/catalog/domain/models/PrincingTypeEnum"


export const CalcTotalsOrderComposition = (prevOrderCompositions: IOrderComposition[], productComposition: IProductComposition): { quantity: number, price: number } => {

    const calcTotalsOrderComposition = () => {
        const orderComposition = prevOrderCompositions.find(prevOrderComposition => prevOrderComposition.id === productComposition.id)
        if (orderComposition) {
            //if (productComposition.pricingType === PrincingTypeEnum.MAX) {
            //    let compositionWithMaxPrice = orderComposition.compositionItems[0];

            //    orderComposition.compositionItems.forEach(item => {
            //        if (item.price > compositionWithMaxPrice.price) {
            //            compositionWithMaxPrice = item;
            //        }
            //    })
            //    const price = compositionWithMaxPrice.totalPrice
            //    const quantity = orderComposition.compositionItems.map(_item => (_item.quantity)).reduce((previousValue, currentValue) => previousValue + currentValue, 0)
            //    return {
            //        quantity, price
            //    }
            //} else {
                const price = orderComposition.compositionItems.map(_item => (_item.totalPrice)).reduce((previousValue, currentValue) => previousValue + currentValue, 0)
                const quantity = orderComposition.compositionItems.map(_item => (_item.quantity)).reduce((previousValue, currentValue) => previousValue + currentValue, 0)
                return { quantity, price }
            //}
        } else {
            return { quantity: 0, price: 0 }
        }
    }
    return (
        calcTotalsOrderComposition()
    )
}
